// src/directives/v-scroll-to.js
import zenscroll from 'zenscroll';

export default {
  mounted(el, binding) {
    // Define and store the click handler
    const clickHandler = () => {
      const config = binding.value;

      if (typeof config !== 'object' || !config.container || !config.el) {
        console.error('v-scroll-to expects an object with "container" and "el".');
        return;
      }

      const container = document.querySelector(config.container);
      const target = document.querySelector(config.el);

      if (!container || !target) {
        console.warn('Could not find container or target element.');
        return;
      }

      const scroller = zenscroll.createScroller(container, 600, 300);
      scroller.to(target);
    };

    el.__vScrollToHandler__ = clickHandler; // store handler on element
    el.addEventListener('click', clickHandler);
  },

  unmounted(el) {
    // Remove using the same handler reference
    el.removeEventListener('click', el.__vScrollToHandler__);
    delete el.__vScrollToHandler__;
  },
};
